import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

export interface WizardStepLayoutProps {
  children?: React.ReactNode
  title: string
  subtitle: string
}

export const WizardStepLayout = ({ title, subtitle, children }: WizardStepLayoutProps) => {
  return (
    <Box flexDirection="column" gap="s24" width="full">
      <Box flexDirection="column" gap="s8" style={{ width: '500px' }}>
        <Text.Header2>{title}</Text.Header2>
        <Text.Normal>{subtitle}</Text.Normal>
      </Box>
      {children}
    </Box>
  )
}
